import React from "react";
import "../../App.css";

export default function Home() {
  return (
    <>
      <h1 className="home">Abhiram Satpute</h1>
    </>
  );
}
